import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export interface SnackbarData {
  message: string
  color?: string
  timeout?: number
}

export const useSnackbarControlStore = defineStore('snackbarControl', () => {
  const snackbarQueue = ref<SnackbarData[]>([])
  const currentSnackbar = ref<SnackbarData | null>(null)

  const closeSnackbar = () => {
    currentSnackbar.value = null

    if (snackbarQueue.value.length > 0) {
      currentSnackbar.value = snackbarQueue.value.shift()!
    }
  }

  return {
    snackbarQueue,
    currentSnackbar,
    closeSnackbar
  }
})

export function launchSnackbar(data: SnackbarData) {
  const store = useSnackbarControlStore()

  if (store.currentSnackbar) {
    store.snackbarQueue.push(data)
  } else {
    store.currentSnackbar = data
  }
}

